import { TrackOccupation } from "@opstel/query/models/trackOccupation";
import { OccupationsForTrackWithOrder } from "@opstel/SBD/core/occupations";
import { TrackTag } from "./TrackTag";
import { getTrackHeight } from "@opstel/SBD/core/functions";
import { LoadingTag } from "./LoadingTag";
import { useDebouncedSelectedTime } from "@shared/common/contexts/SelectedTime/useDebouncedSelectedTime";
import {
  calculateOccupiedLength,
  isBlocked,
  isPassing,
  isThirdParty,
} from "./trackTagCalculations";

interface TrackTagProps {
  readonly occupationsForTrack: OccupationsForTrackWithOrder;
}

const TAG_DEBOUNCE_IN_MS = 50;
export function TrackTagWrapper({ occupationsForTrack: { track, occupations } }: TrackTagProps) {
  const debouncedSelectedTime = useDebouncedSelectedTime(TAG_DEBOUNCE_IN_MS);
  const height = getTrackHeight(track.maxOrder);

  if (debouncedSelectedTime === undefined) {
    return (
      <div className="flex items-start" style={{ height: `${height}px`, minHeight: `${height}px` }}>
        <LoadingTag />
      </div>
    );
  }

  const activeOccupations = TrackOccupation.getActiveOccupations(
    occupations,
    debouncedSelectedTime,
  );
  return (
    <div className="flex items-start" style={{ height: `${height}px`, minHeight: `${height}px` }}>
      <TrackTag
        trackLength={track.length}
        occupiedLength={calculateOccupiedLength(activeOccupations)}
        isPassing={isPassing(activeOccupations)}
        isBlocked={isBlocked(track.blockedDurations, debouncedSelectedTime)}
        isThirdParty={isThirdParty(activeOccupations)}
      />
    </div>
  );
}
